import React, { FC, useContext } from 'react';
import { observer } from 'mobx-react-lite';
import Container from 'react-bootstrap/Container';
import { GameVersionSelector } from '../common/GameVersionSelector';
import Nav from 'react-bootstrap/Nav';
import { CategoriesNavigation } from './Navigation/CategoriesNavigation';
import { Route, Routes } from 'react-router';
import { PubRouteItems, useGetEntitiesLink } from '../../routes';
import { CategoryContainer } from '../category/CategoryContainer';
import { joinRoute, matchDeeply } from '@yakoffice/shared-components';
import { CategoryIndex } from '../category/CategoryIndex';
import RootStoreContext from '../../../model/RootStoreContext';
import { camelToTitle } from '../../../utilities';
import { GameEnvironmentSelector } from '../common/GameEnvironmentSelector';
import type { IGameEnvironment } from '../../../model/gameEnvironment/GameEnvironment';
import { useNavigate } from 'react-router-dom';

import { PublisherViewHeader } from '../../components/publisher-view-header/publisher-view-header';
import { usePageTitle } from '../pageTitleContext/PageTitleContext';

export const CategoriesWrapper: FC = observer(() => {

    const rootStore = useContext(RootStoreContext);
    const navigate = useNavigate();
    const getEntitiesLink = useGetEntitiesLink();
    const { setPageTitle } = usePageTitle();

    const onGameEnvironmentChanged = (targetGe: IGameEnvironment) => {
        if (rootStore.kindVersionStore.currentKindVersion)
            navigate(getEntitiesLink({ gameEnvironmentId: targetGe.id }));
        else
            rootStore.gameEnvironmentsStore.setCurrentGameEnvironment(targetGe.id);
    };

    setPageTitle(['Configurations']);

    const viewHeaderActions = () => {
        return (
            <Nav className="justify-content-end">
                <GameEnvironmentSelector handleGameEnvironmentChange={onGameEnvironmentChanged}
                                         disabled={false}
                                         data-testid="ddlGameEnvironment" />
                <GameVersionSelector />
            </Nav>
        );
    };

    return (
        <div id="categories" className="flexWrapper">
            <PublisherViewHeader
                title="Configurations"
                // subtitle={rootStore.kindVersionStore.currentKindVersion ? camelToTitle(rootStore.kindVersionStore.getCurrentKindVersion().name) : 'Select a kind'}
                subtitlePadding={false}
                customAction={viewHeaderActions()}
            />
            <Container fluid className="h-100 position-relative">
                <CategoriesNavigation />
                <div className="categoriesContentWrapper h-100 position-relative">
                    <Routes>
                        <Route path={PubRouteItems.AddCategory} element={<CategoryContainer />} />
                        <Route path={joinRoute(PubRouteItems.CategoryIdParam, PubRouteItems.AddSubCategory)}
                               element={<CategoryContainer />} />
                        <Route path={PubRouteItems.CategoryIdParam} element={<CategoryContainer />} />
                        <Route path={matchDeeply(PubRouteItems.CategoryIdParam)} element={<CategoryIndex />} />
                    </Routes>
                </div>

            </Container>
        </div>);

});

export default CategoriesWrapper;
